exports.thousandsFormatter = function(num) {
  let isNegative = false
  let formattedNumber = num
  if (num < 0) {
    isNegative = true
  }
  num = Math.abs(num)
  if (num >= 1000000000) {
    formattedNumber = (num / 1000000000).toFixed(1).replace(/\.0$/, '') + 'G'
  } else if (num >= 1000000) {
    formattedNumber = (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M'
  } else if (num >= 1000) {
    formattedNumber = (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K'
  } else {
    let rounded = Math.round(num)
    formattedNumber = rounded === 1000 ? '1K' : rounded
  }
  if (isNegative) { formattedNumber = '-' + formattedNumber }
  return formattedNumber.toString()
}

exports.moneyGetSymbol = function (currencyCode) {
  switch (currencyCode) {
    case 'USD':
      return '$'
    case 'EUR': return '€'
    case 'GBP': return '£'
  }
  return ''
}

exports.usNumberFormat = function (value, precision) {
  if (typeof precision === 'undefined') precision = 2
  value = value + ''
  let sign = ''
  if (value.indexOf('-') === 0) {
    sign = '-'
    value = value.replace('-', '')
  }
  let n = value.replace(/[ ,!-,$]/g, '')
  let c = precision
  let d = '.'
  let t = ','
  c = isNaN(c = Math.abs(c)) ? 2 : c
  d = d === undefined ? ',' : d
  t = t === undefined ? '.' : t
  let i = parseInt(n = (+n || 0).toFixed(c)) + ''
  let j = (j = i.length) > 3 ? j % 3 : 0
  let result = (j ? i.substr(0, j) + t : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : '')
  return sign + result
}

exports.getArrayMaxValue = function(arr) {
  let max = parseFloat(arr[0])
  let len = arr.length
  for (let i = 1; i < len; i++) {
    let v = parseFloat(arr[i])
    max = (v > max) ? v : max
  }
  return max
}

exports.getArrayMinValue = function(arr) {
  let min = parseFloat(arr[0])
  let len = arr.length
  for (let i = 1; i < len; i++) {
    let v = parseFloat(arr[i])
    min = (v < min) ? v : min
  }
  return min
}

exports.getArrayAverage = function (arr) {
  let sum = parseFloat(arr[0])
  let len = arr.length
  for (let i = 1; i < len; i++) {
    sum += parseFloat(arr[i])
  }
  let avg = sum / len
  return avg
}

exports.getMoneyFormatedValue = function (value, currency) {
  let fval = this.usNumberFormat(value, this.getPrecision(currency))
  return fval + ' ' + currency
}

exports.getPrecision = function (currency) {
  if (currency === 'JPY') return 0
  else return 2
}




// WEBPACK FOOTER //
// ./src/core/charts/helper/formatter.js